import React, { useState } from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalInfoCard,
    StandardModalSection,
    StandardModalText,
    Toast
} from "src/components";
import { cancelEmailDowngrade } from "../api/emailCampaignsApi";

export default function EmailCancelDowngradeModal({
    onBack,
    downgradePlan,
    effectiveDate,
    refreshSettings 
}) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);

    const formattedDate = effectiveDate
        ? new Date(effectiveDate).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
        })
        : null;

    const handleCancelDowngrade = async () => {
        try {
            setIsSubmitting(true);
            await cancelEmailDowngrade();
            if (refreshSettings) await refreshSettings();
            setIsConfirmed(true);
            Toast.success("Downgrade successfully cancelled");
        } catch (err) {
            console.error("Cancel downgrade failed", err);
            Toast.error("Failed to cancel downgrade. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <StandardModal
            open={true}
            onClose={onBack}
            title={isConfirmed ? "Downgrade Cancelled!" : "Confirm Cancel Downgrade"}
            description={isConfirmed
                ? "Your scheduled downgrade has been successfully cancelled."
                : "You are about to cancel your scheduled Email plan downgrade."}
            widthMode="large"
            footer={(
                <StandardModalActionGroup $pushRight>
                    {!isConfirmed && (
                        <StandardModalActionButton onClick={onBack}>
                            Close
                        </StandardModalActionButton>
                    )}
                    <StandardModalActionButton
                        $variant="primary"
                        disabled={isSubmitting}
                        onClick={isConfirmed ? onBack : handleCancelDowngrade}
                        width={isConfirmed ? "12rem" : "10.5rem"}
                    >
                        {isConfirmed ? "Go to Email Campaigns" : isSubmitting ? "Processing..." : "Confirm Cancel"}
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection gap="1rem">
                {!isConfirmed && (
                    <StandardModalInfoCard>
                        <StandardModalText weight="700" color="#171A22">Plan Scheduled for Downgrade</StandardModalText>
                        <StandardModalText>{downgradePlan?.title}</StandardModalText>
                    </StandardModalInfoCard>
                )}
                {formattedDate && (
                    <StandardModalInfoCard>
                        <StandardModalText weight="700" color="#171A22">{isConfirmed ? "Was Scheduled From" : "Scheduled Date"}</StandardModalText>
                        <StandardModalText>{formattedDate}</StandardModalText>
                    </StandardModalInfoCard>
                )}
                <StandardModalInfoCard background="var(--calendar-surface-secondary, #F3F5FB)">
                    <StandardModalText weight="700" color="#171A22">{isConfirmed ? "What's Changed" : "This Means"}</StandardModalText>
                    <StandardModalText>
                        {isConfirmed
                            ? "Your current Email plan remains active and will renew as usual."
                            : "Cancelling keeps your current plan active, and the scheduled downgrade will not take effect."}
                    </StandardModalText>
                </StandardModalInfoCard>
                <StandardModalText size="0.875rem">
                    {isConfirmed
                        ? "Your subscription will continue with your current plan."
                        : "You can confirm to cancel the scheduled downgrade now."}
                </StandardModalText>
            </StandardModalSection>
        </StandardModal>
    );
}
